import styled from 'styled-components'
import LiveModal from 'live/components/ui/Modal'

import { CustomListAsyncStyles } from '../../../Form/components/ReportContent/components/GalleryEditor/galleryEditor'

export const LookupButtonContainer = styled.div<{ color: string; lookupStatus: boolean }>`
    margin: 0;
    padding: 8px 0;
    cursor: pointer;
    width: 200px;
    border-bottom: 1px solid ${({ theme }) => theme['gray-300']};
    border-top: 1px solid ${({ theme }) => theme['gray-300']};
    background: ${({ theme }) => theme['white']} !important;

    :hover {
        background-color: ${({ theme }) => theme['gray-100']} !important;
        .toggleStatus {
            span {
                font-weight: 400;
            }
        }
    }

    .section-template {
        display: flex;
        align-items: center;
        padding: 8px 0 16px 0;
        color: ${({ theme }) => theme['gray-800']};
        font-size: 13px;
        font-weight: 400;
        line-height: 16px;
        gap: 8px;

        i {
            color: ${({ theme }) => theme['gray-600']} !important;
            font-weight: 400 !important;
        }

        span {
            font-family: var(--font-italic);
            /* font-weight: ${({ theme, lookupStatus }) => (lookupStatus ? 600 : 400)}; */
            color: ${({ theme }) => theme['gray-800']};
        }
    }

    .section-description {
        font-family: var(--font-regular);

        font-size: 13px;
        font-weight: 400;
        padding: 0 28px 12px 22px;
        p {
            color: ${({ theme }) => theme['gray-700']} !important;
            font-style: italic;
            margin-left: 16px;
        }
    }

    .toggleStatus {
        display: flex;
        align-items: center;
        text-align: center;
        padding: 12px 0 8px 0px;
        justify-content: space-between;
        margin-right: 32px;
        margin-left: 16px;

        .fa-info-circle:before {
            right: 16px;
            position: relative;
        }

        span {
            margin: 0;
            font-family: var(--font-regular);
            color: ${({ theme }) => theme['gray-800']};
            font-size: 13px;
        }
    }

    .addIconActive {
        padding: 0 !important;
    }

    :hover {
        .addIconActive {
            color: ${({ theme }) => theme['blue-500']} !important;
        }

        .section-template {
            span {
                font-weight: 600;
            }
        }
    }
`

export const TemplateModal = styled(LiveModal)<{
     width: number; height: number; isActive: boolean 
     }>`
    .live-notification-service-container {
        .live-global-alert.alert-sm {
            /* border: 2px solid red !important; */
        }
    }

    .modal-header {
        border-radius: 4px 4px 0 0;
        background: ${({ theme }) => theme['gray-200']};

        .modal-title {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            font-family: ${({ theme }) => theme['font-semibold']} !important;
            font-size: 16px;
            font-style: normal;
            line-height: 16px; /* 100% */
            /* font-weight: 600; */
        }
    }

    .modal-content {
        background-color: transparent;
        box-shadow: 0px 2px 9px 0px rgba(18, 23, 32, 0.2);
        border: 1px solid ${({ theme }) => theme['gray-400']};
        border-radius: 4px;
        width: ${({ width }) => width}px;
    }

    .modal-body {
        background-color: ${({ theme }) => theme['gray-0']};

        height: ${({ height }) => height}px;

        .span-dropdown {
            display: flex;
            align-items: center;
            height: 32px;

            i {
                align-items: center;
            }

            .timespan-placeholder {
            }
        }
    }

    .modal-footer {
        padding: 8px 16px;
        background-color: ${({ theme }) => theme['gray-200']};
        border-radius: 0 0 4px 4px;
        height: 48px !important;
    }

    .modal-actions {
        display: flex;
        align-items: center;
        font-family: ${({ theme }) => theme['font-semibold']} !important;
        font-size: 15px;
        font-style: normal;
        font-weight: 600;
        line-height: 16px;

        .saveButton {
            display: flex;
            justify-content: center;
            border-radius: 3px;
            align-items: center;
            font-size: 15px;
            margin-right: 8px;
            height: 32px;
            width: 72px;
            font-family: ${({ theme }) => theme['font-semibold']} !important;

            ${({ theme, isActive=true }) =>
                !isActive &&
                `
    background: var(--blue-400);
    border: 1px solid var(--blue-400);
    color: var(--blue-200);
    opacity: 0.7;
    cursor: not-allowed;
    `}
        }

        span {
            display: none;
        }

        .discardButton {
            display: flex;
            align-items: center;
            justify-content: center;
            border: 1px solid ${({ theme }) => theme['gray-400']};
            border-radius: 3px;
            height: 32px;
            width: 97px;
            font-size: 15px;
            color: ${({ theme }) => theme['gray-800']};
            font-family: ${({ theme }) => theme['font-semibold']} !important;
            /* font-weight: 600; */
        }
    }

    .innerTitleText {
        display: flex;
        font-family: var(--font-regular);
        color: ${({ theme }) => theme['gray-800']};
        font-size: 16px;
        font-style: normal;
        font-family: ${({ theme }) => theme['font-semibold']} !important;
        /* font-weight: 600; */
        line-height: 16px;
        padding: 0 0 16px 0;
    }

    .separator {
        border-bottom: 1px solid ${({ theme }) => theme['gray-400']};
        margin: 24px 0 24px 0;
    }

    .emptyValueTooltip {
        color: ${({ theme }) => theme['gray-700']};
        font-size: 13px;
        font-family: ${({ theme }) => theme['font-regular']} !important;
        font-style: italic;
        /* font-weight: 400; */
        line-height: 18.2px;
        padding-top: 8px;
    }

    .inputHeaderText {
        display: flex;
        color: ${({ theme }) => theme['gray-700']};
        font-family: ${({ theme }) => theme['font-semibold']} !important;
        /* font-weight: 600; */
        font-size: 14px;
        font-style: normal;
        line-height: 16px;
        padding-bottom: 8px !important;
    }

    .sectionTemplateToolTip {
        visibility: visible;
        /* position: absolute;
        left: -32px !important; */
    }

    .toggleText {
        color: ${({ theme }) => theme['gray-800']};
        font-family: var(--font-regular);
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 16px;
        padding-bottom: 8px;
    }
`

const CLASS_PREFIX = `ListAsync--styledMulitSelectCreatable`

export const CustomListAsyncLocal = {
    ...CustomListAsyncStyles,
    menu: styles => ({
        ...styles,
        marginTop: '0px',
        fontFamily: 'var(--font-regular)',
        color: 'var(--gray-800)',
        text: 'ellipsis',
        whitespace: 'nowrap',
        fontSize: '14px',
        fontWeight: '400',
        lineHeight: '16px'
    }),
    indicatorSeparator: styles => ({
        ...styles,
        display: 'none '
    }),
    placeholder: styles => ({
        ...styles,
        position: 'absolute',
        top: '50%',
        color: 'var(--gray-500)',
        textOverflow: 'ellipsis',
        whitespace: 'nowrap',
        fontFamily: 'var(--font-regular)',
        fontSize: '14px'
    })
}
